var option_default = {
  "option": "g-ZWV",
  "user_choice": "_3j8yo",
  "check": "E-vJc",
  "image": "MoOmw",
  "input": "gtpnw",
  "title": "_23mIl",
  "centered": "tustz",
  "with_result": "PaAdG",
  "list": "_2sB6j",
  "with_image": "Re-ra",
  "progress": "d0qnV",
  "progress_value": "HCbLX",
  "label": "QjMuN",
  "cta": "_02FW1",
  "adornment_icon": "piFHo",
  "remove": "sif0i",
  "removeButton": "RVco1",
  "removeButtonIcon": "JeXWb",
  "overlay": "UuecW",
  "shown": "JfiV9",
  "dark": "ZYrLA",
  "spinner": "_0jg71",
  "spin": "r1l3B"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
